import Axios, { AxiosError } from "axios";
import { useQuery, UseQueryOptions } from "react-query";
import { scenarioKeys } from "src/query-keys";
import { Scenario, APIError } from "src/types";

/**
 * Deserialize the json format into a Javascript object
 */
function deserialize(data: Scenario): Scenario {
  return { ...data };
}

export async function queryFn(scenarioId: number | string): Promise<Scenario> {
  const response = await Axios.get(`/planning-api/scenarios/${scenarioId}`);
  return deserialize(response.data);
}

export function useScenario(
  scenarioId: number | string,
  options?: UseQueryOptions<Scenario, AxiosError<APIError[]>, Scenario>
) {
  return useQuery<Scenario, AxiosError<APIError[]>, Scenario>(
    scenarioKeys.detail(scenarioId),
    () => queryFn(scenarioId),
    options
  );
}
